

var debug = require('debug')('CRMMap:Pininfo');
debug.enabled = true;

class Pininfo {

    constructor(CRMMap) {
        this.CRMMap = CRMMap;
        this.infowindow = new google.maps.InfoWindow({
            zIndex: 10000,
            content: "<p>hi</p>"
        });
 
    }


    open(pin) {
        return this.CRMMap.apicall('/transactions/render/' + pin.id, [], true).then((render) => {
             if (!(render == "")) {
                this.infowindow.setContent(render);

              //  this.gmstyleiw = this.CRMMap.element.querySelectorAll('.gm-style-iw')[0];
               // this.gmstyleiw.parentElement.classList.add('CRMMapInfoPopup');
           
              

                this.infowindow.open(this.CRMMap.map, pin.marker);

                for (const element of document.querySelectorAll('.gm-style-iw')) {
                    debug(element);
                    element.parentElement.classList.add('CRMMap_InfoPopup');
                    element.parentElement.classList.add('CRMMap_Info_Back');
                    for (const elementinner of element.parentElement.querySelectorAll('div:first-child div:nth-child(4)')) {
                        elementinner.classList.add('CRMMap_Info_Back');
                    };
                    for (const elementinner of element.parentElement.querySelectorAll('div:first-child div:nth-child(3)')) {
                        elementinner.classList.add('CRMMap_Info_Pointer');
                    };
                 
                    
                  };
               
            }
        });


    }




};

module.exports = Pininfo;

